const atcMenu = document.querySelector(".js-atc-menu");
const atcbar = document.querySelector(".js-bar");
const atcContainer = document.querySelector(".js-atc-container");
const atc = document.querySelector(".js-atc");
const atcBtn = document.querySelector(".js-atc-btn");
const atcDesktop = document.querySelector(".js-atc-desktop");
const body = document.querySelector("body");
let options = {
  rootMargin: "0px",
};
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
        // Le bouton est hors de vue en haut
        // Affiche le sticky
        atcContainer.style.height = "52px";
        atc.classList.add("jc-atc");
        atcMenu.classList.add("jc-atc-menu");
        atcBtn.classList.add("jc-atc-btn");
        atcbar.classList.remove("jc-hidden");
        atcDesktop.classList.add("jc-atc-desktop");
        body.style.paddingBottom = atc.scrollHeight + "px";
      } else if (entry.isIntersecting) {
        // Masque le sticky si le bouton original est visible
        atc.classList.remove("jc-atc");
        atcMenu.classList.remove("jc-atc-menu");
        atcbar.classList.add("jc-hidden");
        atcDesktop.classList.remove("jc-atc-desktop");
        atcBtn.classList.remove("jc-atc-btn");
        body.style.paddingBottom = "0";
      }
    });
  },
  {
    threshold: [0, 0.01], // Se déclenche quand l'élément entre ou sort de la vue, même légèrement
  }
);
observer.observe(atcContainer);
const colorsAmount = document.querySelectorAll(".js-variable-color");
const colorAmountWrapper = document.querySelector("#colors-amount");
let eventUpdateInput = new Event("updateInput", {
  bubbles: true,
});
window.addEventListener("load", (e) => {
  if (document.querySelector("input[jolly-data-type]")) {
    document.querySelector("input[jolly-data-type]").dispatchEvent(eventUpdateInput);
  }
  if (colorAmountWrapper) {
    colorAmountWrapper.innerHTML = colorsAmount.length;
  }
});
const targetNodeoffre = document.querySelector(".js-variant-offre");
if (targetNodeoffre) {
  const configOffre = { attributes: true, childList: true, subtree: true };
  const callbackOffre = (mutationList, observer) => {
    for (const mutation of mutationList) {
      const offres = document.querySelectorAll(".jc-offer");
      for (let i = 0; i < offres.length; i++) {
        if (offres[i].previousElementSibling.classList.contains("disabled")) {
          for (let j = 0; j < offres.length; j++) {
            if (!offres[j].previousElementSibling.classList.contains("disabled")) {
              offres[j].click();
              break;
            }
          }
        }
      }
    }
  };
  const observerOffre = new MutationObserver(callbackOffre);
  observerOffre.observe(targetNodeoffre, configOffre);
}
document.addEventListener("click", selectSizeHandler);
function selectSizeHandler(evt) {
  const btn = evt.target.closest("button[name='add'][type='button']");
  if (!btn) {
    return;
  }
  document.querySelector("[id*='variant_change_'][id*='TAILLE']~div").scrollIntoView({ block: "center" });
}

// window.addEventListener("load", () => {
//   var _a;
//   (_a = document.querySelectorAll(".variantButton_taille-input")) == null ? void 0 : _a.forEach((element, index) => {
//     var _a2;
//     if (index === 1) {
//       element.click();
//       (_a2 = document.querySelectorAll(".variantButton_taille-input")) == null ? void 0 : _a2.forEach((element2, index2) => {
//         if (index2 === 0) {
//           element2.click();
//         }
//       });
//     }
//   });
// });
